import { PercentPipe } from '@angular/common';
import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { useLanguage } from '@sona/angular-util-common';
import { ENVIRONMENT } from '@sona/angular-util-environment';
import { IntlPercentPipe } from 'angular-ecmascript-intl';

import { SubscriptionService } from '../services/subscription.service';

@Component({
    selector: 'sona-pricing-table-page',
    template: `
        <div class="tw-flex tw-flex-col tw-items-center tw-mb-12">
            <h1 class="tw-text-center tw-max-w-[40rem] tw-mb-8">
                {{ 'PAYMENTS.PAGE.PRICING_TABLE.TITLE' | translate }}
            </h1>

            <div class="tw-max-w-3xl tw-mx-auto tw-text-muted-foreground tw-text-base tw-text-center tw-rounded-full tw-py-2 tw-px-4 tw-bg-muted">
                @if (language() === 'de') {
                    Das Barriereifreiheitsstärkungsgesetz tritt am 28. Juni in Kraft.<br />
                    Spare jetzt
                    <strong class="tw-text-[#0061ff]">{{ discountConditions.discountPercentage | intlPercent:{ locale: 'de-DE' } }}</strong>
                    auf dein Abo mit dem Code
                    <span class="tw-bg-[#0d1f3b]/10 tw-py-1 tw-px-1.5 tw-rounded-md tw-font-mono tw-text-[#0d1f3b] tw-ml-0.5 tw-text-sm tw-font-medium">{{ discountConditions.codeDe }}</span>
                    und mache deine Website barrierefrei!
                } @else {
                    The European Accessibility Act comes into effect on June 28<sup>th</sup>.<br />
                    Save
                    <strong class="tw-text-[#0061ff]">{{ discountConditions.discountPercentage | intlPercent:{ locale: 'en-GB' } }}</strong>
                    on your subscription with the code
                    <span class="tw-bg-[#0d1f3b]/10 tw-py-1 tw-px-1.5 tw-rounded-md tw-font-mono tw-text-[#0d1f3b] tw-ml-0.5 tw-text-sm tw-font-medium">{{ discountConditions.codeEn }}</span>
                    and make your website accessible!
                }
            </div>
        </div>

        <stripe-pricing-table
            [attr.pricing-table-id]="pricingTable()"
            [attr.publishable-key]="options.publishableKey"
            [attr.customer-session-client-secret]="customerSession.value()?.client_secret"
        ></stripe-pricing-table>

        <div class="tw-max-w-[50rem] tw-mx-auto tw-p-4 tw-text-xs tw-text-muted-foreground">
            <ul class="tw-m-0 tw-p-4">
                @for (line of 'PAYMENTS.PAGE.PRICING_TABLE.FOOTNOTES' | translate; track line) {
                    <li class="tw-mb-2 last:tw-mb-0">{{ line }}</li>
                }
            </ul>
        </div>
    `,
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    imports: [
        TranslatePipe,
        PercentPipe,
        IntlPercentPipe
    ],
    host: {
        class: 'tw-block tw-h-full tw-p-8 dot-pattern'
    }
})
export class SonaPricingTablePage {

    protected readonly options = inject(ENVIRONMENT).payments;
    protected readonly customerSession = inject(SubscriptionService).getCustomerSession();
    protected readonly language = useLanguage();

    protected readonly pricingTable = computed(() => {
        const language = (this.language() as 'de' | 'en') ?? 'en';

        return this.options.pricingTables[language] ?? this.options.pricingTables.en;
    });
    protected readonly discountConditions = {
        codeDe: 'BFSG',
        codeEn: 'EAA',
        discountPercentage: 0.33
    };
}
